import React, { Component } from "react"
import { FormControl } from "react-bootstrap"
import RoleTypes from "src/pages/hr/Types/RoleTypes"
import mutator from "src/utilities/mutator"
import roleAssignmentHelper from "../../../Utils/RoleAssignmentHelper"
import "./RoleAssignmentSearchRoles.css"

interface Props {
    manageParentState: Function
}

interface State {
    input: string
    searchBusy: boolean
}

class RoleAssignmentSearchRoles extends Component<Props, State> {

    typingTimeout: any = 1000

    state = {
        input: "",
        searchBusy: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    filter = (input: string, roles: RoleTypes[]) => {
        let temp = []
        for (let i = 0; i < roles.length; i++) {
            let str = Object.values(roles[i]).join().toLowerCase()
            if (str.includes(input)) {
                temp.push(roles[i])
            }
        }
        return temp
    }

    debounce = (event: { target: { value: string } }) => {
        const input = event.target.value.toLowerCase()
        this.manageState([{ key: "input", value: input }, { key: "busy", value: true }])
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }

        this.typingTimeout = setTimeout(() => {
            if (input.length > 0) {
                this.props.manageParentState([{ key: "roles", value: this.filter(input, roleAssignmentHelper.allRolesCopy) }])
            } else {
                this.props.manageParentState([{ key: "roles", value: roleAssignmentHelper.allRolesCopy }])
                this.manageState([{ key: "busy", value: false }])
            }
        }, 1000)

    }

    render() {

        const { input } = this.state

        return (
            <div className="RoleAssignmentSearchRoles">
                <FormControl
                    id="e0ff9dd1b54d74b79e87472a4f46c0"
                    onChange={this.debounce}
                    placeholder={"Search roles..."}
                    value={input}
                    type="text"
                />
            </div>
        )
    }
}

export default RoleAssignmentSearchRoles